export default "__VITE_ASSET__CHWPwIFX__"